import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Package, Settings, Globe, LayoutDashboard, Users, Film, Video, Database, FileText } from 'lucide-react';

const menuItems = [
  {
    path: '/admin/products',
    icon: Package,
    label: 'Products Configuration',
  },
  {
    path: '/admin/videos',
    icon: Film,
    label: 'Course Videos',
  },
  {
    path: '/admin/files',
    icon: FileText,
    label: 'Course Files',
  },
  {
    path: '/admin/site-videos',
    icon: Video,
    label: 'Site Videos',
  },
  {
    path: '/admin/enrollments',
    icon: Users,
    label: 'Enrollments',
  },
  {
    path: '/admin/database',
    icon: Database,
    label: 'Database Integrity',
  },
  {
    path: '/admin/system',
    icon: Settings,
    label: 'System Configuration',
  },
  {
    path: '/admin/web',
    icon: Globe,
    label: 'Website Configuration',
  },
  {
    path: '/admin/users',
    icon: Users,
    label: 'Users',
  },
];

export default function AdminSidebar() {
  const location = useLocation();

  return (
    <aside className="w-64 bg-black/40 backdrop-blur-xl border-r border-white/10 min-h-screen pt-24 fixed left-0 top-0">
      <div className="p-6">
        <div className="mb-8">
          <div className="flex items-center space-x-2 text-purple-400 mb-2">
            <LayoutDashboard className="w-5 h-5" />
            <h2 className="text-lg font-semibold">Admin Panel</h2>
          </div>
          <p className="text-xs text-gray-500">Manage your platform</p>
        </div>

        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'bg-purple-600/20 border border-purple-500/30 text-purple-400'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="text-sm font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
